/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      username
      email
      area
      ageGroup
      photo
      personalityScores
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      username
      email
      area
      ageGroup
      photo
      personalityScores
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      username
      email
      area
      ageGroup
      photo
      personalityScores
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createMessageRequest = /* GraphQL */ `
  mutation CreateMessageRequest(
    $input: CreateMessageRequestInput!
    $condition: ModelMessageRequestConditionInput
  ) {
    createMessageRequest(input: $input, condition: $condition) {
      id
      requesterID
      recipientID
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateMessageRequest = /* GraphQL */ `
  mutation UpdateMessageRequest(
    $input: UpdateMessageRequestInput!
    $condition: ModelMessageRequestConditionInput
  ) {
    updateMessageRequest(input: $input, condition: $condition) {
      id
      requesterID
      recipientID
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteMessageRequest = /* GraphQL */ `
  mutation DeleteMessageRequest(
    $input: DeleteMessageRequestInput!
    $condition: ModelMessageRequestConditionInput
  ) {
    deleteMessageRequest(input: $input, condition: $condition) {
      id
      requesterID
      recipientID
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
